import { render, staticRenderFns } from "./airCityAddress.vue?vue&type=template&id=52878d72&scoped=true&"
import script from "./airCityAddress.vue?vue&type=script&lang=js&"
export * from "./airCityAddress.vue?vue&type=script&lang=js&"
import style0 from "./airCityAddress.vue?vue&type=style&index=0&id=52878d72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52878d72",
  null
  
)

export default component.exports